<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-default">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-success">
                        <span class="mdi mdi-division"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>Dividiendo orden</p>
                    </div>
                </div>
                <div class="menu-modal-main-section">
                    <div class="menu-modal-input-container">
                        <div class="menu-modal-input-container-row">
                            <span class="menu-modal-input-label">Ingrese la cantidad a dividir:</span>
                        </div>
                        <div class="menu-modal-input-container-row">
                            <input class="menu-modal-input-general menu-modal-input-number" type="number" min="0" :max="orderReference.real_quantity" step="1" v-model="quantityToSplit" />
                            <input class="menu-modal-input-general menu-modal-input-number menu-modal-input-disabled" type="number" min="0" :max="orderReference.real_quantity" step="1" :value="quantityForSecondInput" />
                        </div>
                        <div class="menu-modal-input-container-row">
                            <input class="menu-modal-input-general menu-modal-input-range" type="range" min="0" :max="orderReference.real_quantity" step="1" v-model="quantityToSplit">
                        </div>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button :class="isQuantityToSplitOkValueClass" :disabled="!isQuantityToSplitOkValue" @click="split">Dividir</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <WarningModal
                v-if="showWarning"
                :warningMessage="warningMessage"
                :closeWarning="closeWarning"
            />
        </transition>
    </div>
</template>

<script>
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import axios from 'axios';
import WarningModal from '../../../../../common/components/modals/WarningModal.vue';
export default {
    name: "SplitOrderReferenceButtonActionModal",
    components: {
        WarningModal
    },
    props: {
        closeModal: {
            type: Function,
            required: true,
        },
        orderReference: {
            type: Object,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            quantityToSplit: 0,
            showWarning: false,
            warningMessage: '',
        }
    },
    methods: {
        split() {
            if (!this.quantityToSplitCheck()) return;
            this.endOfAction();
            this.closeModal();
            axios.get(`/api/order-reference/split/${this.orderReference.id}/${this.quantityToSplit}`)
                .then(res => {
                    showCustomSuccessSweetAlert('Se ha dividido correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        quantityToSplitCheck() {
            if (this.quantityToSplit == 0) {
                this.openWarning('No se pueden extraer 0 cajas')
                return false;
            }
            if (this.quantityToSplit >= this.orderReference.real_quantity) {
                this.openWarning('La cantidad a extraer debe ser menor a la cantidad total')
                return false;
            }
            return true;
        },
        openWarning(warningMessage) {
            this.showWarning = true;
            this.warningMessage = warningMessage;
        },
        closeWarning() {
            this.showWarning = false;
            this.warningMessage = '';
        },
    },
    computed: {
        isQuantityToSplitOkValue() {
            return this.quantityToSplit > 0 && this.quantityToSplit < this.orderReference.real_quantity;
        },
        isQuantityToSplitOkValueClass() {
            return this.isQuantityToSplitOkValue ? 'menu-modal-btn menu-modal-confirm-btn' : 'menu-modal-btn menu-modal-confirm-btn-disabled';
        },
        quantityForSecondInput() {
            return this.orderReference.real_quantity - this.quantityToSplit;
        },
    },
    mounted() {
        const inputElement = this.$el.querySelector('.menu-modal-input-number');
        if (inputElement) {
            inputElement.focus();
            inputElement.select();
            // inputElement.addEventListener('keydown', (event) => {
            //     if (event.key === 'Enter') {
            //         this.split();
            //     }
            // });
        }
    }
};
</script>